<template>
  <el-dialog :close-on-click-modal="false" :title="isEdit ? '编辑收选片角色' : '添加收选片角色'" :visible.sync="isShow" width="500px" @closed="hide()">
    <el-form :model="vo" ref="form" label-width="100px" :rules="rules">
      <el-form-item label="收选片角色" prop="attrName">
        <el-input v-model="vo.attrName"></el-input>
      </el-form-item>
      <el-form-item label="角色图片" prop="image">
        <div>
          <input id="inputImg" type="file" style="display:none;" accept="image/*" @input="uploadImg">
          <el-button size="small" round type="primary" @click="clickInput">上传</el-button>
          <span style="margin-left:20px;">可上传1张图片，建议尺寸850*250px</span>
        </div>
        <el-image v-show="vo.image" style="width: 350px;margin-top: 10px; " :src="vo.image" fit="cover" :preview-src-list="[vo.image]"></el-image>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="isShow = false">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import uploadWebImg from '@/utils/uploadWebImg.js'
import { adminModuleAttributeUpdate, adminModuleAttributeAdd } from '@/api/auxx.js'

export default {
  data () {
    return {
      isShow: false,
      isEdit: false,
      vo: {
        attrName: '',
        image: ''
      },
      rules: {
        attrName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '请上传角色图片', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
  },
  methods: {
    show (isEdit, vo) {
      console.log(isEdit, vo)
      this.isEdit = isEdit
      this.isEdit && (this.vo = vo)
      this.isShow = true
    },
    hide () {
      this.isShow = false
      this.vo = {
        attrName: '',
        image: ''
      }
      this.$nextTick(_ => {
        this.$refs.form.clearValidate()
      })
    },
    clickInput () {
      document.getElementById('inputImg').click()
    },
    uploadImg (e) {
      const loading = this.$loading({
        lock: true,
        text: '正在上传',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      console.log(e.target.files)

      let file = e.target.files[0]

      if (e.target.files[0].type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.$message.error('请上传jpeg/png格式的图片')
        loading.close()
        return
      }
      let url = window.URL || window.webkitURL
      console.log(url.createObjectURL(file))
      let img = new Image()
      img.src = url.createObjectURL(file)

      let _this = this
      img.onload = function () { // onload 加载完成后触发
        console.log('height:' + this.height + '----width:' + this.width)
        if (this.width !== 850 || this.height !== 250) {
          loading.close()
          _this.$message.error('图片尺寸不符合要求')
          return
        }

        uploadWebImg(file, _this.$store.state.awsSdk.product.s3).then(res => {
          _this.vo.image = res
          _this.$refs.form.validateField('image')
          loading.close()
        })
      }
    },
    confirm () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        if (this.isEdit) {
          adminModuleAttributeUpdate(this.vo)
            .then(res => {
              this.$message.success('编辑成功')
              this.$emit('success')
              this.hide()
            })
        } else {
          adminModuleAttributeAdd({
            attrName: this.vo.attrName,
            image: this.vo.image
          })
            .then(res => {
              if (res.data.success) {
                this.$message.success('创建成功')
                this.$emit('success')
                this.hide()
              }
            })
        }
      })
    }
  }
}
</script>

<style>
</style>
